{
  "environments": {
    "netlify": {
      "guest": {
        "deploymentId": "d7fe8968-fa5b-49ff-a16d-61d241d61417"
      }
    },
    "dev": {
      "guest": {
        "deploymentId": "d7fe8968-fa5b-49ff-a16d-61d241d61417"
      }
    },
    "prod": {
      "guest": {
        "deploymentId": "87f6b780-e3e3-4d2b-b2bc-65991b26488e"
      }
    }
  }
}
